import React from "react";
import useApi from "../../hooks/useApi";
import DiscordApiClient from "../../api/discord";
import Card from "../../components/page/Card";
import MensagensDataTable from "./Discord/MensagensDataTable";
import MensagemModal from "./Discord/MensagemModal";
import Validation from "../../helpers/Validation";
import ErrorSwal from "../../components/Swal/errorSwal";
import CommonSwal from "../../components/Swal/commonSwal";

function Discord() {
  const [mensagens, setMensagens] = React.useState([]);
  const [colaboradores, setColaboradores] = React.useState([]);
  const [canais, setCanais] = React.useState([]);
  const [values, setValues] = React.useState({});
  const [mensagemModal, setMensagemModal] = React.useState(false);

  const { request: getMensagens, data: mensagensResponse } = useApi(
    DiscordApiClient.getMensagens
  );
  const { request: getColaboradores, data: colaboradoresResponse } = useApi(
    DiscordApiClient.getColaboradores
  );
  const { request: getCanais, data: canaisResponse } = useApi(
    DiscordApiClient.getCanais
  );
  const getMensagemApi = useApi(DiscordApiClient.getMensagem);
  const salvaMensagemApi = useApi(DiscordApiClient.salvaMensagem);
  const apagaMensagemApi = useApi(DiscordApiClient.apagaMensagem);

  //Busca mensagens ao renderizar tela
  React.useEffect(() => {
    getMensagens();
  }, [getMensagens]);

  //Busca colaboradores ao renderizar tela
  React.useEffect(() => {
    getColaboradores();
  }, [getColaboradores]);

  //Busca canais ao renderizar tela
  React.useEffect(() => {
    getCanais();
  }, [getCanais]);

  //Define o retorno do backend nos valores das linhas
  React.useEffect(() => {
    if (mensagensResponse) setMensagens(mensagensResponse);
  }, [mensagensResponse]);

  //Define o retorno do backend nos valores do estado
  React.useEffect(() => {
    if (colaboradoresResponse) {
      const colaboradoresTratados = trataColaboradores(colaboradoresResponse);
      setColaboradores(colaboradoresTratados);
    }
  }, [colaboradoresResponse]);

  //Define o retorno do backend nos valores do estado
  React.useEffect(() => {
    if (canaisResponse) setCanais(canaisResponse);
  }, [canaisResponse]);

  const trataColaboradores = (colaboradoresTratar) => {
    const colaboradoresTratadosComGrupo = colaboradoresTratar.map(
      (colaborador) => {
        if (colaborador.tipo === "2") {
          return { ...colaborador, grupo: "Cargos" };
        } else if (colaborador.tipo === "1") {
          return { ...colaborador, grupo: "Colaboradores" };
        } else {
          return colaborador;
        }
      }
    );
    return colaboradoresTratadosComGrupo;
  };

  const togMensagemModal = async (uid) => {
    const response = await getMensagemApi.request(uid);
    if (!response) return;
    setValues({ ...response, colaborador: JSON.parse(response.colaborador) });
    setMensagemModal(true);
  };

  const salvaMensagem = async () => {
    const titulo = values?.titulo;
    const formData = new FormData();
    formData.append(
      "colaborador",
      values?.colaborador ? JSON.stringify(values?.colaborador) : ""
    );
    formData.append("canal", values?.canal);

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    const response = await salvaMensagemApi.request(titulo, formData);
    if (!response) return;
    getMensagens();
    setMensagemModal(false);
    CommonSwal({ icon: "success", title: "Mensagem atualizada com sucesso!" });
  };

  const apagaMensagem = async (uid, ativo) => {
    const formData = new FormData();
    formData.append("ativo", ativo);
    const response = await apagaMensagemApi.request(uid, formData);
    if (!response) return;
    getMensagens();
  };

  return (
    <>
      <Card>
        <MensagensDataTable
          linhas={mensagens}
          togMensagemModal={togMensagemModal}
          apagaMensagem={apagaMensagem}
        />
      </Card>
      <MensagemModal
        isOpen={mensagemModal}
        setIsOpen={setMensagemModal}
        valuesHook={{ values, setValues }}
        canais={canais}
        colaboradores={colaboradores}
        salvaMensagem={salvaMensagem}
      />
    </>
  );
}

export default Discord;
